<div class="d-flex align-items-center">
    <ng-container *ngIf="isShowDimention">
        <div class="pallet-dimension-container">
            <div>dimension: {{dimension.width }}x{{dimension.depth}}x{{dimension.height}}</div>
            <div>weight: {{dimension.weight}}kg</div>
            <div>fill approximately: {{pallet.usedSpace| number : '1.2-2'}}%</div>
        </div>
    </ng-container>

    <div class="pallet-thumb-container">
        <img class="pallet-thumb" [src]="appRootUrl() + 'assets/common/images/pallets/pallet.png'"/>

        <div class="pallet-overlay" [ngClass]="getOverlayHeight()"></div>
    </div>
</div>

